<template>
    <div class="order-destination">
        <p class="customer-name" v-if="validCheckoutUser">
            {{getServiceTypeName(serviceType)}} for {{getCustomerName()}}:
        </p>
		<p v-if="!validCheckoutUser">
			<a href="/sign-in" @click.prevent="showLogin">Please Sign in</a>
		</p>
        <div>
            <p v-if="serviceType === EServiceType.SERVICE_TYPE_DELIVERY && deliveryAddress">
				<span class="location-name">From {{location.name}}</span><br/>
				<span v-if="hasComponent('streetNumber')">
					{{getStreetNumber()}} {{getStreetName()}} <span v-if="deliveryAddress.aptNum">{{deliveryAddress.aptNum}}</span><br/>
				</span>
				<span v-if="hasComponent('locality')">{{getLocality()}}, </span>
				<span v-if="hasComponent('postalCode')">{{getPostalCode()}}</span>
            </p>
            <p v-else-if="serviceType === EServiceType.SERVICE_TYPE_TAKEOUT">
                <span class="location-name">From {{location.name}}</span><br/>
				<span v-if="hasComponent('streetNumber')">
					{{getStreetNumber()}} {{getStreetNumber()}} {{formatAptNum(location)}},<br/>
				</span>
				<span v-if="hasComponent('locality')">
					{{getLocality()}}, {{getPostalCode()}}
				</span>
            </p>
        </div>
    </div>
</template>

<script>
import checkoutMixin from "@/components/mixins/checkoutMixin";
import modalMixin from '@/components/mixins/modalMixin';
import Formatter from '@/utils/Formatter';
import Login from '@/components/auth/Login.vue';
import { isEmpty } from 'lodash';

export default {
	mixins: [
		checkoutMixin,
		modalMixin,
	],
	methods: {
		formatAptNum: Formatter.formatAptNum,
		showLogin() {
			this.triggerModal({
				component: Login,
				title: "Login",
				classes: 'global-modal',
				modalName: "loginModal",
				componentProperties: {
					routeTo: '/checkout',
				},
			});
		},
		getAddressComponents() {
			const serviceType = this.serviceType;
			const deliveryAddress = this.deliveryAddress;
			const location = this.location;
			if (!deliveryAddress || !location) {
				return null;
			}
			if (serviceType === this.EServiceType.SERVICE_TYPE_DELIVERY) {
				return this.deliveryAddress.addressComponents;
			}
			return this.location.addressComponents;
		},
		hasComponent(property) {
			const addressComponents = this.getAddressComponents();
			if (!addressComponents) {
				return false;
			}
			return (!isEmpty(addressComponents[property]));
		},
		getComponentProperty(property) {
			const addressComponents = this.getAddressComponents();
			if (!addressComponents) {
				return '';
			}
			return addressComponents[property];
		},
		getStreetNumber() {
			const streetNumber = this.getComponentProperty('streetNumber');
			if (!streetNumber) {
				return '';
			}
			return streetNumber.shortName;
		},
		getStreetName() {
			const streetName = this.getComponentProperty('streetName');
			if (!streetName) {
				return '';
			}
			return streetName.shortName;
		},
		getLocality() {
			const locality = this.getComponentProperty('locality');
			if (isEmpty(locality)) {
				return '';
			}
			return locality.shortName;
		},
		getPostalCode() {
			const postalCode = this.getComponentProperty('postalCode');
			if (isEmpty(postalCode)) {
				return '';
			}
			return postalCode.shortName;
		},
	},
}
</script>

<style lang="scss" scoped>
    .location-name {
        font-weight: 500;
    }

    .order-destination {
        margin-bottom: 1em;
    }
</style>



// WEBPACK FOOTER //
// src/components/checkout/OrderDestination.vue